import { useId } from "react"
import { motion } from "framer-motion"
import { AreaChart, Area } from "recharts"

export function AgentSparkline({ data = [] }) {
  const id = useId()
  const gradientId = `spark-${id.replace(/:/g, "")}`
  const chartData = data.map((runs, i) => ({ i, runs }))
  const hasActivity = data.some((v) => v > 0)

  if (!hasActivity) return null

  return (
    <motion.span
      className="block w-32 h-7 shrink-0"
      initial={{ clipPath: "inset(0 100% 0 0)" }}
      animate={{ clipPath: "inset(0 0% 0 0)" }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <AreaChart width={128} height={28} data={chartData} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#0ea5e9" stopOpacity={0.25} />
            <stop offset="95%" stopColor="#0ea5e9" stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey="runs"
          stroke="#0ea5e9"
          strokeWidth={1.5}
          fill={`url(#${gradientId})`}
          dot={false}
          activeDot={false}
          isAnimationActive={false}
        />
      </AreaChart>
    </motion.span>
  )
}
